export default __webpack_public_path__ + "static/media/img-45.98f54f84.jpg";